export const environment = {
  production: true,
  urlCommom:"https://servicescommon.epharma.com.br/"
};
